export const insurSmartTitle = 'Before you proceed these are specific terms and conditions for setting up your home insurance policy';

export const insurSmartPtOne = 'Policy will commence at least 2 working days before mortgage drawdown.';

export const insurSmartPtTwo = 'Direct debit to pay home insurance premiums set up on the same account as the mortgage direct debit.';

export const insurSmartPtThree = 'First payment will be taken within 10 working days, then 1st of every month.';

export const insurSmartPtFour = 'If you want to change your mind – contact us X days before drawdown.';

export const insurSmartPtFive = 'Quote valid for 90 days only.';

export const insurSmartCheckText = 'Please tick to confirm that you have advised the customer of the appropriate T&Cs and they have confirmed that they understand and accept before proceeding.';

export const insurSmartErrorMsg = 'Please confirm you have read the terms and conditions for an InsurSmart policy';

export const insurSmartProcced = 'Do you understand and are you happy to proceed?';

export const insurSmartStartDateChange = 'As the policy Start Date has changed, in order to close out this InsurSmart journey and the Home policy bind, please click the Complete button and continue with the bind process via Applied connect.';
